import { Box, Typography } from "@mui/material";

function SectionHeader(props) {
  const {
    superheader,
    title,
    subtitle,
    size = 1,
    // className,
    // fontWeight,
    bgcolor,
    styles,
    bgImage,
    textAlign,
    ...otherProps
  } = props;

  // Render nothing if no title or subtitle
  if (!title && !subtitle) {
    return null;
  }

  return (
    <Box
      component="header"
      sx={{
        width: "100%",
        padding: "7px 3px",
        borderRadius: "5px",
        backgroundColor: bgcolor,
        backgroundImage: bgImage,
        ...(textAlign && { textAlign }),
        ...styles,
        // "&:not(:last-child)": {
        //   marginBottom: "2rem",
        // },
      }}
      {...otherProps}
    >
      {superheader && (
        <Typography
          variant={size === "p" ? "body1" : "h3"}
          sx={{
            fontWeight: 700,
            fontSize: "0.8rem",
            maxWidth: 700,
            display: "inline-block",
            textTransform: "uppercase",
          }}
        >
          {superheader}
        </Typography>
      )}

      {title && (
        <Typography
          variant={size === "p" ? "body1" : `h${size}`}
          gutterBottom={props.subtitle ? true : false}
          sx={{
            fontSize: {
              xs: "1.4rem",
              md: "2rem",
            },
            fontWeight: 500,
            overflowWrap: "anywhere",
            maxWidth: "100%",
            ...(textAlign && { textAlign }),
          }}
        >
          {title}
          {title.endsWith("Brains for Robots") && (
            <sup style={{ fontSize: "1rem", fontWeight: "600" }}>®</sup>
          )}
        </Typography>
      )}

      {subtitle && (
        <Typography
          component="p"
          sx={{
            fontWeight: props.subtitleFontWeight,
            fontSize: props.subtitleFontSize ?? {
              xs: "0.95rem",
              sm: "1rem",
              md: "1.05rem",
            },
            lineHeight: 1.55,
            maxWidth: "min(700px, 100%)",
            ...(textAlign === "center" && {
              marginLeft: "auto",
              marginRight: "auto",
            }),
            display: "block",
            overflowWrap: "anywhere",
            ...(textAlign && { textAlign }),
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export default SectionHeader;
